<template>
  <v-list>
    <template v-for="(item, i) in items">
      <v-divider
        :key="i"
      ></v-divider>
      <v-list-item
        :key="item.id"
        :href="urlHostName(item.hostName)"
        :to="urlHostName(item.hostName) ? null : getLink(item.id, (item.family || {}).id)"
      >
        <v-list-item-avatar
          size="30"
        >
          <v-icon
            v-if="item.icon && item.icon.startsWith('mdi-')"
            class="primary white--text"
            v-text="item.icon"
            size="20"
          ></v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title
            class="title-multiline"
          >
            <v-tooltip
              :key="item.id"
              :disabled="item.tooltip == null"
              transition="fade-transition"
              bottom
            >
              <template v-slot:activator="{  on }">
                <span v-on="on">{{item.name}}</span>
              </template>
              <span >{{ item.tooltip }}</span>
            </v-tooltip>
          </v-list-item-title>
        </v-list-item-content>
        <slot name="item-actions" v-bind:item="item"></slot>
      </v-list-item>
    </template>
  </v-list>
</template>

<script>
export default {
  name: 'LinksList',
  props: {
    preffix: {
      type: String,
      default: '',
    },
    items: Array,
  },
  methods: {
    getLink(id, idFamily) {
      let [preffix, pId = ''] = [this.preffix, id];
      if (preffix.endsWith('/')) {
        preffix = preffix.slice(0, -1);
      }
      if (pId.startsWith('/')) {
        pId = pId.slice(1);
      }

      if (preffix.includes('?')) {
        const start = preffix.indexOf('?');
        preffix = preffix.substr(0, start);
      }

      let path = '';
      const paths = preffix.split('/');
      if (idFamily === this.$getConst('categoryFamily') && paths.length > 2) {
        path = `/request/${paths[2]}/subcatalog/${pId}`;
      } else {
        path = `${preffix}/${pId}`;
      }

      return path;
    },
    urlHostName(url) {
      if (url !== null) {
        return /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\\/]))?/.test(url) ? url : null;
      }
      return null;
    },
  },
};
</script>

<style lang="scss" scoped>
  .title-multiline {
    word-break: break-word;
    white-space: normal;
  }
</style>
